import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../../context/auth/authContext';
import './MatchTypeModal.css';

const MatchTypeModal = ({ onClose }) => {
  const { user } = useContext(AuthContext);

  // Check user game preferences
  const showVGC = user?.gamePreferences ? user.gamePreferences.vgc === true : true;

  return (
    <div className="modal-overlay match-type-modal-overlay" onClick={onClose}>
      <div className="modal-container match-type-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Log a Match</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          <div className="match-type-buttons">
            <Link to="/log-match/tcg" className="btn btn-primary" onClick={onClose}>
              <i className="fas fa-plus"></i> Log TCG Match
            </Link>
            <Link to="/import-match" className="btn btn-primary" onClick={onClose}>
              <i className="fas fa-file-import"></i> Import PTCGL
            </Link>
            {showVGC && (
              <Link to="/log-match/vgc" className="btn btn-primary" onClick={onClose}>
                <i className="fas fa-plus"></i> Log VGC Match
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchTypeModal;